// extracted by mini-css-extract-plugin
export default {"feed":"Feed_feed__WmFNu","inputContainer":"Feed_inputContainer__hFE72","input":"Feed_input__7nC2v","options":"Feed_options__OWqsW"};